/**
 * Максимальная длина заголовка фильтра
 */
export const MAX_TITLE_LENGTH = 21;

/**
 * Максимальное количество выбранных категорий для отображения в заголовке
 */
export const MAX_TYPES_IN_BUTTON = 2;

/**
 * Количество символов, после которых выбранная категория обрезается, заменяясь на "..."
 */
export const TITLE_SLICE = 20;
export const TITLE_SLICE_MOBILE = 7;
